export const loaderConstants = {
  START_LOADER: "START_LOADER",
  STOP_LOADER: "STOP_LOADER",
};
